import { createContext, useContext } from "react";

export const LanguageContext = createContext({
  changeLanguage: (language: string) => {},
  language: `en`,
});

export const useLanguage = () => useContext(LanguageContext);
